
export const EMOTIONAL_INT_MAX_SCORE = 65;
export const EMOTIONAL_INTELLIGENCE_ADD_MAP = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
